module.exports = __webpack_public_path__ + "static/android-icon-192x192-fe8be34262a81d548c6c205cd63d5dd1.png";